import React from "react";
import { StandardButton } from "./StandardButton.style";

interface Props {
  onClick: () => any | string;
}

export default StandardButton;
